import classnames from "classnames";
import { Button, Select, Typography } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";

import CopyToClipboardButton from "components/CopyToClipboardButton";

import { FRAMEWORK_SELECT_OPTIONS } from "./constants";
import SyntaxHighlighter from "./SyntaxHighlighter";

const CodeBlock = ({
  title = (
    <div>
      <Trans i18nKey="neetoMolecules.codeblock.codeSnippet" />
    </div>
  ),
  codeString,
  showCopyButton = true,
  className = "",
  sendViaEmail = undefined,
  frameworkProps = {},
}) => {
  const { t } = useTranslation();
  const { selectedFramework, setSelectedFramework } = frameworkProps ?? {};

  return (
    <div className={classnames(["relative", className])}>
      <div className="neeto-ui-rounded-lg neeto-ui-border-gray-200 neeto-ui-bg-gray-50 flex w-full flex-wrap items-center justify-between gap-2 rounded-b-none border p-3">
        {title && (
          <Typography
            className="m-0 flex-shrink-0"
            data-testid="code-block-title-text"
            style="h4"
          >
            {title}
          </Typography>
        )}
        {selectedFramework && (
          <Select
            className="max-w-40"
            data-testid="framework-select"
            options={FRAMEWORK_SELECT_OPTIONS}
            value={selectedFramework}
            onChange={setSelectedFramework}
          />
        )}
        <div className="ms-auto flex flex-shrink-0 items-center justify-end gap-2">
          {sendViaEmail ? (
            <Button
              style="tertiary"
              label={t(
                "neetoMolecules.widget.installation.snippet.sendViaEmail"
              )}
              onClick={sendViaEmail}
            />
          ) : null}
        </div>
      </div>
      <div className="relative">
        {showCopyButton && (
          <CopyToClipboardButton
            className="absolute right-3 top-3"
            size="small"
            style="secondary"
            value={codeString}
            tooltipProps={{
              content: t("neetoMolecules.widget.installation.snippet.copy"),
            }}
          />
        )}
        <SyntaxHighlighter
          className="neeto-ui-bg-gray-800 neeto-ui-rounded-lg m-0 rounded-t-none pt-4"
          code={codeString}
          language="javascript"
        />
      </div>
    </div>
  );
};

CodeBlock.propTypes = {
  title: PropTypes.object,
  codeString: PropTypes.string,
  showCopyButton: PropTypes.bool,
  className: PropTypes.string,
  sendViaEmail: PropTypes.func,
  frameworkProps: PropTypes.object,
};

export default CodeBlock;
